import { HttpResponse } from '@angular/common/http';
import { CheckCondition } from './interfaces';
import { EventKind, HealthMetricStatus } from '@lentau/analytics/health-metrics/shared';
import { isEmptyResponse, isErrorResponse, isNotJsonResponse } from './helper';

export const checks: CheckCondition[] = [
  {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    condition: (response: HttpResponse<any>) => response.status === 204,
    eventData: { status: HealthMetricStatus.Ok },
  },
  {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    condition: (response: HttpResponse<any>) => isNotJsonResponse(response.body),
    eventData: {
      status: HealthMetricStatus.Exception,
      properties: [{ key: 'kind', value: EventKind.PARSING }],
    },
  },
  {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    condition: (response: HttpResponse<any>) => isEmptyResponse(response.url, response.body),
    eventData: {
      status: HealthMetricStatus.Exception,
      properties: [{ key: 'kind', value: EventKind.EMPTY }],
    },
  },
  {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    condition: (response: HttpResponse<any>) => isErrorResponse(response.body),
    eventData: {
      status: HealthMetricStatus.Exception,
      properties: [{ key: 'kind', value: EventKind.SERVER }],
    },
  },
];
